/**
 * 社交媒体相关数据
 */
export const socialContactList = [
  {
    icon: "telegram",
    title: "telegram",
    type: "telegram",
    sub: [
      {
        title: "SuperEx Global",
        link: "https://t.me/SuperExOfficial"
      },
      {
        title: "SuperEx Iran DAO",
        link: "https://t.me/SuperexIR"
      },
      {
        title: "SuperEx Russia DAO",
        link: "https://t.me/superexrussia"
      },
      {
        title: "SuperEx Nigeria DAO",
        link: "https://t.me/SuperexNGDAO"
      },
      {
        title: "SuperEx Turkey DAO",
        link: "https://t.me/SuperExTR"
      },
      {
        title: "SuperEx Bangladesh DAO",
        link: "https://t.me/BDSuperEx"
      },
      {
        title: "SuperEx India DAO",
        link: "https://t.me/SuperexIN"
      },
      {
        title: "SuperEx Indonesia DAO",
        link: "https://t.me/SuperexID"
      },
      {
        title: "SuperEx Español DAO",
        link: "https://t.me/SuperexESP"
      },
      {
        title: "SuperEx Arabic DAO",
        link: "https://t.me/SuperexArabic"
      },
      {
        title: "SuperEx Afrique DAO",
        link: "https://t.me/SuperexAFRIQUE"
      },
      {
        title: "SuperEx Brazil DAO",
        link: "https://t.me/SuperexBR"
      },
      {
        title: "SuperEx Pakistan DAO",
        link: "https://t.me/SuperexPK"
      },
      {
        title: "SuperEx Ukraine DAO",
        link: "https://t.me/SuperexUKR"
      },
      {
        title: "SuperEx Malaysia DAO",
        link: "https://t.me/SuperexMY"
      },
      {
        title: "SuperEx Vietnam DAO",
        link: "https://t.me/SuperEx_Viet"
      }
    ]
  },
  {
    icon: "twitter",
    title: "twitter",
    type: "twitter",
    sub: [
      {
        title: " SuperEx Global ",
        link: "https://twitter.com/SuperExet"
      },
      {
        title: " SuperEx Vietnam DAO ",
        link: "https://twitter.com/SuperEx_VietNam"
      },
      {
        title: " SuperEx Nigeria DAO ",
        link: "https://twitter.com/SuperEx_NG"
      },
      {
        title: " SuperEx Arabic DAO ",
        link: "https://twitter.com/ArabicSuperex"
      },
      {
        title: " SuperEx Turkey DAO ",
        link: "https://twitter.com/TrSuperex"
      },
      {
        title: " Superex Español DAO ",
        link: "https://twitter.com/SuperexESP"
      },
      {
        title: " SuperEx Brazil DAO ",
        link: "https://twitter.com/SuperexBr"
      },
      {
        title: " SuperEx Bangladesh DAO ",
        link: "https://twitter.com/SuperexBD"
      },
      {
        title: " SuperEx Iran DAO ",
        link: "https://twitter.com/SuperExPersian"
      },
      {
        title: " SuperEx India DAO ",
        link: "htttps://twitter.com/SuperExIndia"
      },
      {
        title: " SuperEx Philippines DAO ",
        link: "https://twitter.com/SuperExPH"
      }
    ]
  },
  {
    icon: "ins",
    title: "ins",
    type: "ins",
    link: "https://www.instagram.com/superexdex/"
  },
  {
    icon: "medium",
    title: "medium",
    type: "medium",
    link: "https://superex.medium.com/"
  },
  {
    icon: "discord",
    title: "discord",
    type: "discord",
    link: "https://discord.gg/superex"
  },
  {
    icon: "youtube",
    title: "youtube",
    type: "youtube",
    link: "https://www.youtube.com/@superexdex"
  },
  {
    icon: "facebook",
    title: "facebook",
    type: "facebook",
    link: "https://www.facebook.com/superexdex"
  },
  {
    icon: "cmc",
    title: "cmc",
    type: "cmc",
    link: "https://coinmarketcap.com/exchanges/superex/"
  }
];

/**
 * 网站地图相关数据
 */
export const siteMapList = [
  {
    title: "300262",  //300262
    sub: [
      {
        title: "300263",  //300263  服务协议
        // link: "https://support.superex.com/hc/en-001/articles/11479008598553"
      },
      {
        title: "300264",  //300264
        // link: "https://support.superex.com/hc/en-001/articles/11478863478809"
      },
      {
        title: "300265",  //300265
        // link: "https://support.superex.com/hc/en-001/categories/4410470420249"
      }
    ]
  },
  {
    title: "300266",  //300266
    sub: [
      {
        title: "300267",   //300267
        // link:
        //   "https://support.superex.com/hc/en-001/categories/4412787796889-Beginner-s-Center"
      },
      {
        title: "300268",   //300268
        // link:
        //   "https://support.superex.com/hc/en-001/categories/4410478890137-Spot-Leveraged-Trading"
      },
      {
        title: "300269",
        // link:
        //   "https://support.superex.com/hc/en-001/categories/4410478992793-Futures-Trading"
      },
      {
        title: "FAQ",
        // link:
        //   "https://support.superex.com/hc/en-001/categories/4412774906905-FAQ"
      }
    ]
  },
  {
    title: "300271",  //300271
    sub: [
    //   {
    //     title: "300272",   //300272
    //     link: "/userCenter/fee/trading"
    //   },
    //   {
    //     title: "300273",   //300273
    //     link: "/rule"
    //   },
      {
        title: "300274",   //上币申请
        // link: "https://docs.google.com/forms/d/e/1FAIpQLSd0zIRGvBWB2Bv_fmiwqSMTx5vAcaPi7n443Jjj49UG8j-kOg/viewform"
      },
    //   {
    //     title: "300275",
    //     link: ""
    //   },
      {
        title: "DAO",
        // link: "https://support.superex.com/hc/en-001/articles/6736531883033-SuperEx-Global-DAO-Recruitment"
      },
    //   {
    //     title: "400014",  //400014 ET Zone
    //     link: "https://www.superex.live/et"
    //   }
    ]
  },
  {
    title: "300276",    //300276
    sub: [
      {
        title: "300277",   //300277
        // link: "https://support.superex.com/hc/en-001"
      },
      {
        title: "300278",   //300278
        link: "https://support.superex.com/hc/en-001/requests/new"
      },
      {
        title: "300279",   //300279
        link: "mailto:business@superex.com"
      },
      {
        title: "300280",   //300280
        link: "mailto:gbg@superex.com"
      }
    ]
  },
  {
    title: "SCS",
    sub: [
      { title: "SCS Chain", link: "https://scschain.com/" },
      { title: "400010", link: "https://scschain.com/stayTuned.html#module-contact" },  //  400010  Mainnet Explore
      { title: "400011", link: "https://testnetscan.scschain.com/" },  //400011    Testnet Explore
      { title: "400012", link: "https://superexchain.github.io/?_gl=1*1plk7v4*_ga*MTMyMzUzOTkyNy4xNjg5NTgyNTg2*_ga_W94SCVN3FF*MTcwMDQ4MTAyMi44Ni4xLjE3MDA0ODEwMzguNDQuMC4w" }   //400012  Developer Docs
    ]
  },
//   {
//     title: "400013",   //400013 其他
//     sub: [
//     //   { title: "DAO Network", link: "/" },
//     //   { title: "Roadmap", link: "/" },
//       { title: "300069"},
//       { title: "300066"}
//     ]
//   }
];



// WEBPACK FOOTER //
// ./src/data/site-map.js